import { useContext, useState } from "react";
import { useSelector } from "react-redux";
import UiContext from "@store/ui-context";
import useAPIRequest from "@custom_hooks/simple/useAPIRequest";

const defaultVerifSetting = {
  jabatan_id: -1,
  pnj: [],
};

// verify (sign) a row of the kartu stok as PNJ: kartu_stok_minyak:pnj
export const useAPIVerifKartuStokMinyak = (props) => {
  const { onVerified } = props;

  const uiContext = useContext(UiContext);
  const employee = useSelector((state) => state.auth.employee);
  const { requestGet, requestPost } = useAPIRequest();

  const [verifSetting, setVerifSetting] = useState({ ...defaultVerifSetting });

  //  API call section

  const fetchVerifSetting = async () => {
    return requestGet({
      fullUrl: "/api/masterdata/verifsetting/data",
      params: { filter: `label:contains:kartu_stok_minyak%` },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
      onSuccess: ({ data, message }) => {
        const newVerifSetting = {
          ...defaultVerifSetting,
          pnj: [],
          jabatan_id: employee?.jabatan_id ?? -1,
        };
        for (const verifData of data ?? []) {
          const { label, jabatan_id } = verifData;
          const newVerifLabel = label.replace(`kartu_stok_minyak:`, "").trim();
          if (newVerifSetting[newVerifLabel]) {
            newVerifSetting[newVerifLabel].push(jabatan_id);
          }
        }
        setVerifSetting(newVerifSetting);
      },
    });
  };

  const verifyPnj = async ({ id, username, password }) => {
    const body = { data_id: id, label: "kartu_stok_minyak:pnj" };
    if (username) body["username"] = username;
    if (password) body["password"] = password;

    return await requestPost({
      fullUrl: `/api/user/verif`,
      body: body,
      onSuccess: ({ message, data: responseData }) => {
        uiContext.showSuccessMsg("Success", "Verifikasi berhasil");
        if (onVerified) onVerified(id, responseData);
      },
      onError: ({ message, data }) => {
        uiContext.showErrorMsg("Error", message);
      },
    });
  };

  return { verifSetting, fetchVerifSetting, verifyPnj };
};
